export class Identifier {
    'id';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return Identifier.attributeTypeMap;
    }
    constructor() {
    }
}
